import { useState } from "react";
import { ISupplierModalProps } from "../types/modal";

import { useAppDispatch } from "../hooks/redux";
import { closeModalById, openModal } from "../features/modals";

import { useFormik } from "formik";
import axios from "axios";

import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  DialogContent,
  TextField,
  Stack,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

import supplierSchema, { SupplierBase } from "../schemas/supplier";
import PermissionGuard from "../components/PermissionGuard";
import PERMISSIONS from "../constants/permissions";
import MODALS from "../constants/modals";

const SupplierModal: React.FunctionComponent<ISupplierModalProps> = ({
  id,
  callback,
  initialValues,
}) => {
  const dispatch = useAppDispatch();

  const [isDeleting, setIsDeleting] = useState(false);

  const {
    values,
    dirty,
    handleChange,
    setFieldValue,
    handleSubmit,
    errors,
    resetForm,
    submitCount,
  } = useFormik<SupplierBase>({
    initialValues: {
      name: initialValues ? initialValues.name : "",
      email: initialValues ? initialValues.email : "",
      phone: initialValues?.phone,
    },
    onSubmit: (values) => {
      axios
        .put(
          "/classifiers/suppliers",
          initialValues ? { _id: initialValues._id, ...values } : values
        )
        .then(() => {
          callback();
          handleClose();
        })
        .catch((err) => {
          console.log("err:", err);
        });
    },
    validationSchema: supplierSchema,
  });

  const handleDelete = (id: string) => {
    setIsDeleting(true);
    axios
      .delete(`/classifiers/suppliers/${id}`)
      .then(() => {
        callback();
        handleClose();
      })
      .catch((err) => {
        console.log("err:", err);
        setIsDeleting(false);
      });
  };

  const handleClose = () => {
    dispatch(closeModalById(id));
  };

  return (
    <Dialog fullWidth={true} maxWidth="xs" open={true} onClose={handleClose}>
      <DialogTitle>{"_id" in values ? "Labot" : "Pievienot"} piegādātāju</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <TextField
            id="name"
            label="Nosaukums"
            variant="standard"
            value={values.name}
            onChange={handleChange}
            error={Boolean(errors.name) && submitCount > 0}
            helperText={submitCount > 0 && errors.name}
          />
          <TextField
            id="email"
            label="E-pasts"
            variant="standard"
            value={values.email}
            onChange={handleChange}
            error={Boolean(errors.email) && submitCount > 0}
            helperText={submitCount > 0 && errors.email}
          />
          <TextField
            id="phone"
            label="Tālrunis (neobligāts)"
            variant="standard"
            value={values.phone}
            onChange={handleChange}
            error={Boolean(errors.phone) && submitCount > 0}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Aizvērt</Button>
        <PermissionGuard permission={PERMISSIONS.DELETE_SUPPLIERS}>
          {({ hasAccess }) => (
            <>
              {hasAccess && initialValues ? (
                <LoadingButton
                  loading={isDeleting}
                  onClick={() => {
                    dispatch(
                      openModal({
                        type: MODALS.Approve,
                        title: "Vai tiešām dzēst piegādātāju?",
                        message: "Piegādātājs tiks dzēsts neatgriezeniski.",
                        onApprove: () => {
                          handleDelete(initialValues._id);
                        },
                      })
                    );
                  }}
                  color="error"
                  variant="outlined"
                >
                  Dzēst
                </LoadingButton>
              ) : null}
            </>
          )}
        </PermissionGuard>
        <Button
          disabled={isDeleting}
          onClick={() => {
            handleSubmit();
          }}
          variant="contained"
        >
          {initialValues ? "Saglabāt" : "Pievienot"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SupplierModal;
